// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"rfLaFB9","sellerDetails":"rfLaFB9","seller-name":"QoZtGMl","sellerName":"QoZtGMl","badge":"T_OABqJ","promoted-gig-text":"WU9lG2_","promotedGigText":"WU9lG2_"};